import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import CustomInput from '../../CustomComponents/FormInputs'
import { useLocation, useNavigate } from 'react-router'
import { withOidcSecure } from '@axa-fr/react-oidc';
import Modal from "../../CustomComponents/Modal";
import ClimbIcon from '../../../assets/images/illo-climb.png';
import ClimbIconForPlus from '../../../assets/kudzu-plus-images/Climb-logo.png';
import { useDispatch, useSelector, connect } from 'react-redux';
import { SAVING, appTheme, retrieveData, showKudzuPlusPrompt } from '../../../helpers/utils/Utils';
import { STATUS_SUCCESS_CODE, GET_CLIMB_FEATURES, CLIMB_OPT_IN_OUT, CAN_CREATE_SAVINGS_ACC, COVERED_BY_KUDZU, COVERED_BY_KUDZU_PLUS, SAVINGS_GOALS, GET_MANAGE_SAVING_GOAL, GET_MANAGE_SAVING_GOAL_V2,SAVING_CARD_CODE } from '../../../network/URLConstants';
import { GetApiHeadersWithBearer, GetRequest, PostRequest } from '../../../network/NetworkUtils';
import Loader from '../../CustomComponents/Loader';
import Tickicon from '../../../assets/images/Check_white.png';
import lock from '../../../assets/images/lock.png';
import union from '../../../assets/images/Union.png';
import checkrounded from '../../../assets/images/Check_Round.png';
import SpendIcon1 from '../../../assets/images/illo-spendsense.png';
import SpendIcon2 from '../../../assets/images/spend_alert_2-1.png';
import SavingHabitIcon1 from '../../../assets/images/savings-habits-1.png';
import RadialFill from '../../../assets/images/Radial Fill.png'
import RadialNull from '../../../assets/images/Radial Null.png'
import Arrow from '../../../assets/images/arrow.png';

import CoveredByKudzuIcon1 from '../../../assets/images/savings-habits.png';
import LineBreaks, { addLineBreaks } from "../../../utils";
import moment from "moment";
import CustomAlertModel from "../../CustomComponents/CustomAlertModel";
import logFirebaseEvents from "../../LogFirebaseEvents";
import CustomModalPlus from "../../../kudzu_plus/helpers/customModalPlus";
import Cookies from 'js-cookie';
import MemnershipEnrollmentScreens from "../../../kudzu_plus/components/membershipEnrollmentScreens";
import ArrowWhite from '../../../assets/kudzu-plus-images/arrow-image.png';
import illoBeneficiaryDark from "../../../assets/kudzu-plus-images/illo-beneficiary-dark.png";
import Frame1336 from "../../../assets/kudzu-plus-images/LearnMoreCarouselTrail/Frame1336.png";
import illoEmailUpdatedDarkNew from "../../../assets/kudzu-plus-images/illo-email-updated-dark-new.png";
import { getUserMembership } from "../../../helpers/utils/Utils";



const Climb = (props) => {
  const { opacityLow, isClimbg,savingsGoalsIntoTrue,initialSavingsGoalModalClose } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const currentpath = useLocation();
  const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
  const appThemeData = appTheme(kudzuPlusTrue)

  const ShowPromptsTrue = useSelector(state => state.ShowPromptsTrue);
  const climbPopShowValueFromStore = useSelector(state => state.climbPopShowValue);
  const [isLoading, setIsLoading] = useState(false);
  const [isClimbModalOpen, setIsClimbModalOpen] = useState(climbPopShowValueFromStore);
  const cards = useSelector(state => JSON.parse(state.userCards));
  const loggedResponse = useSelector(state => JSON.parse(state.loggedInResponse));
  const accessToken = useSelector(state => state.accessToken);

  const [isClimbings, setisClimbings] = useState([]);
  const [disclosureAgrmt, setDisclosureAgrmt] = useState(false);

  //spend alerts
  const [isClimbFeaturesModalOpen, setIsClimbFeaturesModalOpen] = useState(false);
  const [isSpendModalOpen1, setSpendModalOpen1] = useState(false);
  const [isSpendModalOpen2, setSpendModalOpen2] = useState(false);
  const [isSpendModalOpen3, setSpendModalOpen3] = useState(false);

  //saving habits
  const [isSavingHabitModalOpen1, setIsSavingHabitModalOpen1] = useState(false);
  const [isSavingHabitModalOpen2, setIsSavingHabitModalOpen2] = useState(false);
  const [isSavingHabitModalOpen3, setIsSavingHabitModalOpen3] = useState(false);





  // saveGoals
  const [isSpendModalOpen4, setSpendModalOpen4] = useState(false);
  const [isHandleSavingGoals1, setIsHandleSavingGoals1] = useState(false);
  const [isHandleSavingGoals2, setIsHandleSavingGoals2] = useState(false);
  const [isHandleSavingGoals3, setIsHandleSavingGoals3] = useState(false);
  const [isHandleSavingGoals4, setIsHandleSavingGoals4] = useState(false);
  

  


  //Covered By Kudzu
  const [IsCoveredByKudzuModalOpen1, setIsCoveredByKudzuModalOpen1] = useState(false);
  const [isCoveredByKudzuModalOpen2, setIsCoveredByKudzuModalOpen2] = useState(false);
  const [isCoveredByKudzuModalOpen3, setIsCoveredByKudzuModalOpen3] = useState(false);
  const [isCoveredByKudzuDiscloserOpen, setIsCoveredByKudzuDiscloserOpen] = useState(false);
  const [isCoveredByKudzuOptInSuccess, setIsCoveredByKudzuOptInSuccess] = useState(false);
  const [isCoveredByKudzuIneligible, setIsCoveredByKudzuIneligible] = useState(false);
  const [isCoveredByKudzuIneligibleSetupSavings, setIsCoveredByKudzuIneligibleSetupSavings] = useState(false);
  const [isCoveredByKudzuIneligibleSetupSavingsPostPopup, setIsCoveredByKudzuIneligibleSetupSavingsPostPopup] = useState(false);
  const [isCoveredByKudzuPlusIneligible, setIsCoveredByKudzuPlusIneligible] = useState(false);
  
  const HighlightMsgStyles = "sm:w-auto w-[253px] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal  text-[var(--modal-text-highlight)] cursor-pointer pointer-events-none";
  const HeaderMsgStyles = "text-[var(--modal-text-heading-clr)] font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
  const HeaderMsgStylesForPlus = "font-serif-pro text-white modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
  const summaryParagraphStyles = "font-hanken-grotesk modal-title text-[#94C3E8] lg:text-[13px] md:text-[13px] sm:text-[6px] text-[8px] font-[400] cursor-pointer pointer-events-none";
  const SubHeaderMsgStyles = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
  const SubHeaderMsgStylesPlus = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none text-[var(--modal-text-heading-clr)]";
  const [highlightMsg, setHighlightMsg] = useState('')
  const [headerMsg, setheaderMsg] = useState('')
  const [subHeaderMsg, setSubHeaderMsg] = useState('')
  const [btn1Exists, setBtn1Exists] = useState(false)
  const [btn2Exists, setBtn2Exists] = useState(false)
  const [btn1Text, setBtn1Text] = useState(false)
  const [btn2Text, setBtn2Text] = useState('')
  const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
  const [footerMsg, setFooterMsg] = useState('');
  const [showModel, setShowModel] = useState(false);
  const [modelImage, setModelImage] = useState('')
  const [savingsTheme, setSavingsTheme] = useState(false);
  const [isBorderNone, setisBorderNone] = useState(true);
  const [isSubFooter, setIsSubFooter] = useState(false);
  const [carousel, setCarousel] = useState('');
  const [summaryParagraph, setSummaryParagraph] = useState('');
  const [opacityValueLow, setOpacityValueLow] = useState(false);
  const [showPlusModal, setShowPlusModal] = useState(false);
  const [comparisonScreen, setComparisonScreen] = useState('');
  const [fullWidth, setFullWidth] = useState(false);
  const [footerButtonEnable, setFooterButtonEnable] = useState(false);
  const [gradientButton, setGradientButton] = useState(false);
  const [largeImage, setLargeImage] = useState(false);
  const [skipAndNextButtonsEnable, setSkipAndNextButtonsEnable] = useState(false);
  const [showCarouselScreenShow, setShowCarouselScreensShow] = useState(false);
  const [subFooter, setSubFooter] = useState('');
  


  const kudzuplusTrue = useSelector(state => state.kudzuPlusTrue);
  const showPrompt = showKudzuPlusPrompt(loggedResponse);
  // const kudzuplusTrue = false;

  const [btn1BgColor, setBtn1BgColor] = useState("");
 const [page, setPage] = useState(1);
      const [hasMore, setHasMore] = useState(true);

  const isPrimrayKey = cards !== null ? cards[0].CardKey : 0;
  const accessTokenToApi = useSelector(state => state.accessToken);

  const SubHeadingStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal  text-[var(--modal-text-heading-clr)]";
  const SubHeadingStyles2 = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal  text-[var(--modal-text-highlight)]";
  const SubHeadingStyles2ForPlus = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[37px] font-normal  text-[#94C3E8] pl-1 pr-1 mb-4";
  const SubHeadingStyles3 = "font-hanken-grotesk modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[30px] lg:leading-[38px] md:leading-[30px] leading-[30px] font-normal text-[var(--modal-text-heading-clr)]";
  const savingsCardExist = cards?.some(item => item.AccountTypeName === "Savings")
  const savingsWithBalanceOver50 = cards.find(
    obj => obj.AccountTypeBit63 == 32 && obj.Balance >= 50
  );
  const savingsCardAvailable = useSelector(state => state.savingsAccontAvailable);
  const currentPathFromStoreVal = useSelector(state => state.currentPathFromStore);
  const climbFeatures = useSelector(state => state.climbFeatures);
  
   const issavingsGoalEligible = climbFeatures?.find(item => item?.code === SAVINGS_GOALS);
  const isMobile = /Mobi|Android/i.test(navigator.userAgent);
  console.log(cards, '6846')

  const closeClimbVerificationModal = () => {
    dispatch({ type: 'CLIMB_POPUP_SHOWVALUE', payload: { climbPopShowValue: false } });
    setIsClimbModalOpen(false);
  };

  //close modal redirection to manage cards

  const currentPath = window.h

  const closeSkipModal = () => {
   debugger
    if (isClimbModalOpen) {
      navigate(currentPathFromStoreVal);
    }
    else if (isClimbFeaturesModalOpen) {
      setIsClimbFeaturesModalOpen(false)
      setIsClimbModalOpen(true)
    }
    else if (isSpendModalOpen1) {
      setSpendModalOpen1(false)
      setIsClimbFeaturesModalOpen(true)
    }
    else if (isSpendModalOpen2) {
      setSpendModalOpen2(false)
      setIsClimbFeaturesModalOpen(true)
    }
    else if (isSpendModalOpen3) {
      setSpendModalOpen3(false)
      setIsClimbFeaturesModalOpen(true)
    }
    else if (isSpendModalOpen4) {
      setSpendModalOpen4(false);
      setIsClimbFeaturesModalOpen(true);
    }
    else if (isSavingHabitModalOpen1) {
      setIsSavingHabitModalOpen1(false)
      setIsClimbFeaturesModalOpen(true)
    }
    else if (isSavingHabitModalOpen2) {
      setIsSavingHabitModalOpen2(false);
      setIsSavingHabitModalOpen1(true)
    }
    else if (isSavingHabitModalOpen3) {
      setIsSavingHabitModalOpen3(false);
      setIsSavingHabitModalOpen2(true)
    }
    else {
      navigate('/home');

    }
  };

  ////open modal setp wise
  const OpenClimbFeaturesModal = () => {
    setIsClimbFeaturesModalOpen(true);

  };



  //climb features modal


  const handleClimbFeatures = async () => {
    logFirebaseEvents("climb", "Continue_Clicked", "Continue_Clicked", "", "");
    if (isPrimrayKey == undefined || isPrimrayKey == null) {
      return
    }
    setIsLoading(true);
    const deviceId = await retrieveData('updatedDeviceId')
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const url = GET_CLIMB_FEATURES.replace('{CARD_KEY}', isPrimrayKey)
    const response = await GetRequest(url, headers);
    const responseJson = JSON.parse(response);
    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) {
      const enabledClimbings = responseJson.Response.filter(
        (response) => response.enabled === true

      );
      setisClimbings(enabledClimbings);
      dispatch({ type: 'UPDATE_CLIMB_FEATURE', payload: { climbFeatures: responseJson.Response } })
      setIsLoading(false);
    } else {
      return [];
    }

  }


  const canCreateSavingsAccount = async () => {
    const deviceId = await retrieveData('updatedDeviceId');
    const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
    setIsLoading(true)

    let finalUrl = CAN_CREATE_SAVINGS_ACC(cards[0].CardKey)
    var response = await GetRequest(finalUrl, headers)
    var responseObj = JSON.parse(response)
    setIsLoading(false)
    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
      const canCreateNew = responseObj.Response.canCreateNew
      const eligibleDate = moment(responseObj.Response.eligibleDate).format('MM/DD/YYYY')
      if (canCreateNew) {
        enrollSavingsAccount()

      } else {
        setIsCoveredByKudzuIneligibleSetupSavings(false);
        showAlertModal(true, t("oh_no"), t('unable_to_open'), `${t('u_will_be_eligible')} ${eligibleDate}. `, true, false, t('home'), '', true, require('../../../assets/images/illo-report.png'), false, false, true)
      }
    } else {
      setTimeout(() => {
        var arrMessages = responseObj.Messages;
        var message = arrMessages[0];
        var displayText = message.DisplayText;
        showAlertModal(true, t("oh_no"), displayText, '', true, false, t('home'), '', true, require('../../../assets/images/illo-report.png'), false, false)

        // setError(displayText)
      }, 500);
    }
  }

  // kudzu plus learn more popup


  useEffect(() => {
    // const isplusModalClosedFromClimb = localStorage.getItem('plusModalClosedFromClimb') === 'true';
    const tooltipCookieNameForClimbGet = `freeTrial_modal_Climb${cards[0].CardKey}`;
    const modalShown = Cookies.get(tooltipCookieNameForClimbGet);
    debugger;
    if (showPrompt && !kudzuplusTrue) {
      if (modalShown == undefined) {
        showAlertModalPlus(true, t("thanks"),addLineBreaks(t("Climb_to_greater_heights_with_a_free_3-Month_Kudzu+")), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../assets/kudzu-plus-images/leaf.png'), "", true, "#262B3A", addLineBreaks(t('*A_$4.95_monthly_membership_fee_will_be_automatically')), true, '', '', false, true, true);
      }
      else {
        if (modalShown == "false") {
          showAlertModalPlus(true, t("thanks"), addLineBreaks(t("Climb_to_greater_heights_with_a_free_3-Month_Kudzu+")), "", true, true, t('Learn_More'), t('No_Thanks'), true, require('../../../assets/kudzu-plus-images/leaf.png'), "", true, "#262B3A", addLineBreaks(t('*A_$4.95_monthly_membership_fee_will_be_automatically')), true, '', '', false, true, true);
        } else {
          setIsClimbModalOpen(true)
        }
      }
    }
    else if (kudzuplusTrue) {
      setIsClimbModalOpen(true)
    }
    else {
      setIsClimbModalOpen(true)
    }
    // else {
    //   setIsClimbModalOpen(true)
    // }
  }, [])

  useEffect(() => {
    return () => {
      dispatch({ type: 'CLIMB_POPUP_SHOWVALUE', payload: { climbPopShowValue: false } });
    };
  }, [dispatch]);


  const showAlertModalPlus = (showPlusModal, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, carousel, isBorderNone, btn1BgColor, summaryParagraph, opacityValue, comparisonScreen, fullWidth, footerButtonEnable, gradientButton, largeImage,subFooter) => {
    setShowPlusModal(showPlusModal)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setBtn1Exists(btn1Exists)
    setBtn1Text(btn1Text)
    setCarousel(carousel)
    setisBorderNone(isBorderNone)
    setBtn1BgColor(btn1BgColor)
    setSummaryParagraph(summaryParagraph)
    setOpacityValueLow(opacityValue)
    setComparisonScreen(comparisonScreen)
    setFullWidth(fullWidth)
    setFooterButtonEnable(footerButtonEnable)
    setGradientButton(gradientButton)
    setLargeImage(largeImage)
    setSubFooter(subFooter)
  }

  const onAcptBtnClick = async () => {
    setShowModel(false)
    if (btn1Text == t('home')) {
      navigate('/home')
    }
  }
  const onCancelBtnClick = () => {
    setShowModel(false);

  }

  const subComponent = () => {
    return (
      <div className=' flex justify-start items-start'>
        <p className="font-hanken-grotesk font-semibold sm:font-[500] sm:text-[14px] md:text-[20px] text-[16px] md:leading-[30px] leading-[24px]">{t("pl_contact_customer")}<span className="text-[#2965FB] cursor-pointer" onClick={
          () => window.open("https://www.kudzumoney.com/contact-us", '_blank')}>{t("support_email")}</span>{t("for_access")}</p>
      </div>
    )
  }

  const enrollSavingsAccount = () => {
    setIsCoveredByKudzuIneligibleSetupSavings(false);
    if (kudzuPlusTrue) {
      showAlertModalPlus(true, "", <p className='mb-6'><span className='text-[var(--modal-text-highlight)]'>{t('Let’s_get_started_climb')}</span>{" "}{t('with_creating_a_Kudzu+_savings_account')}</p>,
        t("set_aside_money_for_things_that_matter"),
        false, false, t("enroll"), t("may_be_later"), false,
        require('../../../assets/kudzu-plus-images/Benificiary.png'), "", true, "#262B3A",
        '', true, '', false, false, false, true, <button type="button"
          onClick={() => {
            setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false); dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('came_from_climb') } });
            navigate('/SetupSavingsAccount');
          }}
          className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[16px] md:text-[16px] sm:text-[14px] text-[16px]
text-white cursor-pointer flex justify-end items-center w-full" >
        {t('next')} <img
          src={ArrowWhite}
          className="md:w-[9px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[9px] h-[14px] ml-2"
          alt="ArrowWhite" />
      </button>
      );
    }
    else {
      setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(true);
    }
  }

  const closeCustomAlertModal1 = () => {
    setShowModel(false);
  }


  const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, savingsTheme, isBorderNone, isSubFooter) => {
    setShowModel(showModel)
    setHighlightMsg(highlightMsg)
    setheaderMsg(headerMsg)
    setSubHeaderMsg(subHeaderMsg)
    setBtn1Exists(btn1Exists)
    setBtn2Exists(btn2Exists)
    setBtn1Text(btn1Text)
    setBtn2Text(btn2Text)
    setBtn1TypeAcpt(btn1TypeAcpt)
    setModelImage(modelImage)
    setSavingsTheme(savingsTheme)
    setisBorderNone(isBorderNone)
    setIsSubFooter(isSubFooter)

  }

  const coveredByKudzuOptIn = async (item) => {

    setIsClimbFeaturesModalOpen(false);
    setIsCoveredByKudzuModalOpen3(false);

    setIsLoading(true);
    const url = CLIMB_OPT_IN_OUT.replace('{CARD_KEY}', cards[0].CardKey) + 'CoveredByKudzu' + '/opt-in'
    const deviceId = await retrieveData('updatedDeviceId')
    const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
    const response = await PostRequest(url, {}, headers)

    setTimeout(() => {
      setIsLoading(false)
    }, 500);

    const responseObj = JSON.parse(response);

    if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {

      setIsClimbFeaturesModalOpen(false);
      setIsCoveredByKudzuDiscloserOpen(false);
      setIsCoveredByKudzuOptInSuccess(true);
    } else {

      setIsClimbFeaturesModalOpen(true);
      setIsCoveredByKudzuDiscloserOpen(false);
      var arrMessages = responseObj.Messages;
      var message = arrMessages[0];
      var displayText = message.DisplayText;
    }

  }

  const MangageSpendAlerts = () => {
    logFirebaseEvents("climb", "Managed_Skip_Clicked", "Managed_Skip_Clicked", "", "");
    setIsClimbModalOpen(false)
    setIsClimbFeaturesModalOpen(false)
    setSpendModalOpen1(false)
    setIsSavingHabitModalOpen1(false)
    // navigate('/Climb/ClimbMenu');
  }


  const handleSpendAlertIntoro2 = () => {
    setIsClimbFeaturesModalOpen(false);
    setSpendModalOpen1(false);
    setSpendModalOpen2(true);

  };

  const handleSpendAlertIntoro3 = () => {
    setIsClimbFeaturesModalOpen(false);
    setSpendModalOpen1(false);
    setSpendModalOpen2(false);
    setSpendModalOpen3(true);
  };

  // savings Habit
  const handleSavingsHabitIntro2 = () => {
    logFirebaseEvents("climb", "Learn_More_Saving_Habit_Clicked", "Learn_More_Saving_Habit_Clicked", "", "");

    setIsClimbFeaturesModalOpen(false);
    setIsSavingHabitModalOpen1(false);
    setIsSavingHabitModalOpen2(true);
  }

  const handleSavingsHabitIntro3 = () => {
    logFirebaseEvents("climb", "Get_Start_Saving_Habit_Clicked", "Get_Start_Saving_Habit_Clicked", "", "");
    setIsClimbFeaturesModalOpen(false);
    setIsSavingHabitModalOpen1(false);
    setIsSavingHabitModalOpen2(false);
    setIsSavingHabitModalOpen3(true);
  };

  
  const handleButtonClick = (item) => {
    debugger;
    switch (item.code) {
      case "SpendingAlert":
        logFirebaseEvents("climb", "Spending_Alert_Clicked", "Spending_Alert_Clicked", "", "");
        if (item.hasConfigurations) {
          navigate('/Climb/ManageSpendAlerts');
        } else {
          setIsClimbFeaturesModalOpen(false);
          setSpendModalOpen1(true);
        }
        break;
      case "CoveredByKudzu":
        logFirebaseEvents("climb", "Covered_By_Kudzu_Clicked", "Covered_By_Kudzu_Clicked", "", "");
        if (item.code != "SpendingAlert" && savingsCardAvailable == false) {
          setIsClimbFeaturesModalOpen(false);setIsSavingHabitModalOpen3(false); setIsCoveredByKudzuIneligibleSetupSavings(true); setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false)
        } else {
          if (item.optedIn) {
            navigate('/Climb/ManageCoveredByKudzu');
          }
          else {
            navigate('/Climb/CoveredByKudzu');
          }
        }

        break;
      // Add more cases for other displayText values
      case "SavingsHabit":
        logFirebaseEvents("climb", "Savings_Habit_Clicked", "Savings_Habit_Clicked", "", "");
        if (item.code != "SpendingAlert" && !savingsCardExist) {
          setIsSavingHabitModalOpen3(false); setIsCoveredByKudzuIneligibleSetupSavings(true); setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false)
        }
        // else if ( savingsCardExist && savingsWithBalanceOver50 == undefined){
        //   callAddMoneyToSavingsAccount();
        // }
        else {
          if (item.hasConfigurations) {
            navigate('/Climb/ManageSavingsHabit');
          } else {
            setIsClimbFeaturesModalOpen(false);
            setIsSavingHabitModalOpen1(true);
          }
        }
        break;
      // Add more cases for other displayText values
      case "SavingsGoal":
        // Handle click for Option 2
        if (showPrompt) {
          setIsClimbFeaturesModalOpen(false)
          const currentPath = { currentPathFromStore: currentpath.pathname };
          dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
          setShowCarouselScreensShow((prev) => !prev);
          const data = { kudzuFlowFrom: "climFooter" };
          dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
        }    ////  need to change
        else {
          if(item.optedIn){
            if (issavingsGoalEligible?.hasConfigurations) {
              navigate('/Climb/SavingGoals/ManageSavingGoal')
            }
            else {
              setIsClimbFeaturesModalOpen(false)
              setSpendModalOpen4(true)
            }
          }else{
            navigate('/Climb/SavingGoals/ManageSavingGoal')
          }
        }

        break;
      case "CoveredByKudzuPlus":
        logFirebaseEvents("climb", "Covered_By_Kudzu_Plus_Clicked", "Covered_By_Kudzu_Plus_Clicked", "", "");
        if(kudzuPlusTrue){
          if(item.optedIn){
            navigate('/Climb/ManageCoveredByKudzu')
          }
          else{
           navigate('/Climb/CoveredByKudzuPlus');
          }
        }
        else{
          return
        }
        break;
      // Add more cases for other displayText values
      default:
        // Default click handler
        break;
    }
  }





  const callAddMoneyToSavingsAccount = () => {
    setIsCoveredByKudzuIneligibleSetupSavings(false);
    setIsClimbFeaturesModalOpen(false);
    setIsCoveredByKudzuIneligible(true)
  }
  const closeCustomAlertModal = () => {
    // setIsCoveredByKudzuIneligible(false);
    setIsCoveredByKudzuIneligible(false);
    setIsClimbFeaturesModalOpen(true);

  }

  const closeModelPlus = () => {
    setShowCarouselScreensShow(false);
    setShowPlusModal(false)
    if (subHeaderMsg == t("set_aside_money_for_things_that_matter")) {
      setIsCoveredByKudzuIneligibleSetupSavings(true)
    }
    else {
      setIsClimbModalOpen(true)
    }
  }
  const onAcptBtnClickPlusModal = () => {
    // navigate("/memnershipEnrollmentScreens")
    logFirebaseEvents("Climb", "Kudzu_Plus_Learn_More_Clicked", "Kudzu_Plus_Learn_More_Clicked", "", "");
    setShowPlusModal(false)
    const currentPath = { currentPathFromStore: currentpath.pathname };
    dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
    setShowCarouselScreensShow((prev) => !prev);
    const data = { kudzuFlowFrom: "Climb" };
    dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
  }

  const onCancelBtnClickPlusModal = () => {
    // localStorage.setItem('plusModalClosedFromClimb', 'true');
    logFirebaseEvents("Climb", "Kudzu_Plus_No_Thanks_Clicked", "Kudzu_Plus_No_Thanks_Clicked", "", "");
    const tooltipCookieNameForClimb = `freeTrial_modal_Climb${cards[0].CardKey}`;
    Cookies.set(tooltipCookieNameForClimb, 'true', { expires: 1825 });
    setShowPlusModal(false);
    setIsClimbModalOpen(true)
  }



  const handleCoveredByKudzuPlus = () => {
      setIsClimbFeaturesModalOpen(false)
      const currentPath = { currentPathFromStore: currentpath.pathname };
      dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
      setShowCarouselScreensShow((prev) => !prev);
      const data = { kudzuFlowFrom: "climbCoveredByKudzu" };
      dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
    // navigate("/memnershipEnrollmentScreens")
  }
  
  const handleSavingGoals = () => {
    if (!kudzuplusTrue) {
      setIsClimbFeaturesModalOpen(false)
      const currentPath = { currentPathFromStore: currentpath.pathname };
      dispatch({ type: 'CURRENT_LOCATION', payload: currentPath });
      setShowCarouselScreensShow((prev) => !prev);
      const data = { kudzuFlowFrom: "climFooter" };
      dispatch({ type: 'KUDZU_PLUS_FROM', payload: data });
    } else {
      setIsClimbFeaturesModalOpen(false)
      setSpendModalOpen4(true)
    }
  }

  const handleButtonClickGradient = (item) =>{
    switch (item.code) {
      case "CoveredByKudzuPlus":
        logFirebaseEvents("climb", "Covered_By_Kudzu_Plus_Clicked", "Covered_By_Kudzu_Plus_Clicked", "", "");
        handleCoveredByKudzuPlus()
        break;
      case "SavingsGoal":
        logFirebaseEvents("climb", "Savings_Goals_Clicked", "Savings_Goals_Clicked", "", "");
        handleSavingGoals()
        break;
      // Add more cases for other displayText values
      default:
        // Default click handler
        break;
    }

  }


const handleSavingGoals1 = () => {
  setSpendModalOpen4(false);
  setIsHandleSavingGoals1(true);
};
const handleSavingGoals2 = () => {
  setIsHandleSavingGoals1(false);
  setIsHandleSavingGoals2(true);
};
const handleSavingGoals3 = () => {
  setIsHandleSavingGoals2(false);
  setIsHandleSavingGoals3(true);
};
  const manageSavingData = useSelector(state => state.manageSavingData)

const handleSavingGoals4 = () => {
  setIsHandleSavingGoals3(false);
  setSpendModalOpen4(false) 
 
  setIsHandleSavingGoals4(true);
 
};

const GetManageSavingGoalData = async () => {
  const deviceId = await retrieveData("updatedDeviceId");
  const headers = await GetApiHeadersWithBearer(deviceId, accessToken);
   const savingsAccount = cards.find(account => account.AccountTypeBit63 == SAVING_CARD_CODE);
  const url = GET_MANAGE_SAVING_GOAL_V2(savingsAccount?.CardKey , page);
  try {
    const response = await GetRequest(url, headers);
    const responseJson = await JSON.parse(response);
    if (responseJson.ResponseCode === STATUS_SUCCESS_CODE) { 
      const DataArray = responseJson.Response.Items || [];
      if (DataArray.length === 0) {
          setHasMore(false);  
      } else {
      dispatch({type:'MANAGE_SAVING_TOTAL_COUNT',  payload : {manageSavingTotalCount: responseJson.Response.TotalItemsCount}})
      dispatch({type:'MANAGE_SAVING_DATA',  payload : {manageSavingData: responseJson.Response.Items}})
          setPage((prevPage) => prevPage + 1);  
      }
   
    }
  } catch (error) {
    console.log("error", error);
  }
};
 
    useEffect(()=>{
      GetManageSavingGoalData()
      handleClimbFeatures()
    },[])

useEffect(() => {
  if (savingsGoalsIntoTrue) {
    if (issavingsGoalEligible?.hasConfigurations ) {
      setIsHandleSavingGoals4(false)
      navigate('/Climb/SavingGoals/ManageSavingGoal')
    } else {
      setIsClimbModalOpen(false)
      setIsClimbFeaturesModalOpen(false)
      setIsHandleSavingGoals4(true)
    }
  }
}, [savingsGoalsIntoTrue,manageSavingData,issavingsGoalEligible])




  // console.log(kudzuplusTrue, showPrompt ,"phani conditions")

  const  handleFeatureScreenshow = () =>{
    closeClimbVerificationModal();
    OpenClimbFeaturesModal();
    setIsClimbModalOpen(false)
  }


    const userMembershipData = getUserMembership(loggedResponse)
    const handleTermsClick = () =>{
          if (accessTokenToApi == undefined || accessTokenToApi == null) {
            return;
        }
        else {
            navigate('/Documents/Policies/Covered%20by%20Kudzu%20Terms%20and%20Conditions', { state: { name: 'Covered by Kudzu Terms and Conditions', 
              url:
              userMembershipData?.membershipType === "Plus" ||
              userMembershipData?.membershipType === "Trial"
              ? "CoveredByKudzuPlusTerms"
              : "CoveredByKudzuTerms", accType: 64, CardKey: cards?.[0]?.CardKey } });
        
        }
        }

  return (
    <div>
      {showCarouselScreenShow &&
        <MemnershipEnrollmentScreens />}
      <Modal
        isOpen={isClimbModalOpen}
        onClose={closeSkipModal}
        isClimbg={true}
        isKudzuPlusBg={showPrompt || kudzuplusTrue ? true : false}
        bgColor={kudzuplusTrue || showPrompt ? 'bg-[#262B3A]' : 'bg-white'}
        opacityLow={opacityValueLow}
        subtitle={(
          <>
            <span className={`${SubHeadingStyles} ${kudzuplusTrue || showPrompt ? 'text-white' : ''}`}>
              {t("climbInfo")}
            </span>
            {/* <span className={`${kudzuplusTrue || showPrompt ? SubHeadingStyles2ForPlus : SubHeadingStyles2}`}>
              {t("Toolkit")}
            </span> */}
            <span className={`${SubHeadingStyles} ${kudzuplusTrue || showPrompt ? 'text-white' : ''}`}>
              {t("climbinfo2")}
            </span>
          </>
        )}
        content={(
          <div className={`pt-10  ${kudzuplusTrue || showPrompt  ? 'pb-[8.5rem]' : 'pb-10'}`}>
                       {kudzuplusTrue || showPrompt ?
              <img src={ClimbIconForPlus} className="" alt="" /> :
              <img src={ClimbIcon} className="block sm:m-auto mx-auto lg:w-[220px] lg:h-[220px] md:w-[170px] md:h-[170px] w-[129px] h-[129px] my-16" alt="" />}
            <div className="sm:absolute md:right-[-50px] sm:right-[0px] bottom-[0.5rem] w-full">
              <div className="flex sm:justify-end justify-between md:gap-14 sm:gap-8">
                <button
                  type="button"
                  className={`font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--skip-climb-modal-color)] flex items-center`}
                  onClick={MangageSpendAlerts}
                >
                  {t('skip')}
                </button>
                <button
                  type="button"
                  className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--continue-climb-modal-color)] cursor-pointer flex items-center"
                  onClick={handleFeatureScreenshow}
                >
                  {t('continue')}
                  <img
                    src={appThemeData.ClimbArrow}
                    className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
                    alt="Arrow"
                  />
                </button>
              </div>
            </div>
          </div>
        )}
      />


      {/* 
      ////climb features */}
      <Modal
        isOpen={isClimbFeaturesModalOpen}
        onClose={closeSkipModal}
        isClimbg={true}
        // bgColor={kudzuplusTrue === true && showPrompt === false ? 'bg-hsba(226, 38%, 22%, 1)' : 'bg-white'}
        isKudzuPlusBg={showPrompt || kudzuplusTrue ? true : false}
        bgColor={kudzuplusTrue ? 'bg-[#262B3A]' : showPrompt ? 'bg-[#262B3A]' : 'bg-white'}
        subtitle={
          <>
            <span
              className={`${SubHeadingStyles2} ${(kudzuplusTrue || showPrompt ) ? 'text-#7EC0EE' : ''}`}
            >
              {t("lets_get_climbing")} 
            </span>
            <p
              style={kudzuplusTrue || showPrompt ? { color: '#FFFFFF' } : {}}
              className={`${SubHeadingStyles} ${kudzuplusTrue ? 'text-[#7EC0EE]' : showPrompt ? 'text-[#7EC0EE]' : ''}`}
            >
              {t("where_woukd_you_like_to_start")}
            </p>
          </>
        }
        content={
          <div className="pt-16 pb-10">
            {!kudzuplusTrue && !showPrompt && (
              <div className="flex flex-col justify-center items-center gap-4">

                {isClimbings.map(item => (
                  <button
                  key={item.id}
                  className={`w-[255px] md:h-[65px] sm:h-[60px] h-[60px] md:text-[16px] text-[15px] font-hanken-grotesk bg-[#2965FB]
               rounded-full px-4 py-2 text-white ${(item.code !== "CoveredByKudzu" ? item.optedIn : false ? 'opacity-50 cursor-not-allowed' : '')}`}
                  disabled={item.code !== "CoveredByKudzu" ? item.optedIn : false}
                  onClick={() => handleButtonClick(item)}
                >
                    <div className="flex flex-row align-center justify-center items-center">
                      <div className="flex w-[150px]">{item.displayText}</div>
                      { item.optedIn && (
                        <div className="inline-block pl-3 align-middle">
                          <img src={Tickicon} alt="Tick Icon" />
                        </div>
                      )}
                    </div>
                  </button>
                ))}
              </div>
            )}

            {/* Show additional buttons based on conditions */}
            {(showPrompt) && (
              <div className="flex flex-col justify-center items-center gap-4">
                {isClimbings.filter((data) => data.code !== COVERED_BY_KUDZU_PLUS && data.code !== 'SavingsGoal').map((item) => (
                  <button
                    key={item.id}
                    className={`w-[300px] md:h-[65px] sm:h-[60px] h-[60px] md:text-[16px] text-[15px] font-hanken-grotesk 
                  rounded-full px-4 py-2 text-white border-[2.5px] border-[hsla(45,6%,100%,1)] 
                  ${item.code !== "CoveredByKudzu" && item.optedIn === false ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={item.code === "CoveredByKudzu" && item.optedIn}
                    onClick={() => handleButtonClick(item)}
                  >
                    <div className="flex flex-row justify-center items-center">
                      <div className="flex items-center mr-2">
                        <img src={checkrounded} alt="Icon" className="w-[17.5px] h-[17.5px]" />
                      </div>
                      <div className="flex w-[170px] ml-4">{item.displayText}</div>
                      {/* {item.code !== "SpendingAlert" && !savingsCardAvailable && (
                        <div className="flex items-center ml-2">
                          <img src={lock} alt="Lock Icon" />
                        </div>
                      )} */}
                    </div>
                    
                  </button>
                ))}
                {isClimbings
                  .filter((data) => data.code === COVERED_BY_KUDZU_PLUS || data.code === 'SavingsGoal')
                  .map((item) => (
                    <button type="button" className="flex  items-center justify-center rounded-full w-[300px] md:h-[65px] sm:h-[60px] h-[60px] bg-gradient-to-r from-[#2965FB] via-[#4B70B9] to-[#30BC89] p-[2px] text-white  lg:text-[16px]  sm:text-[11px] text-[15px] md:text-[16px] md:leading-[46.09px] sm:leading-[22.8px] leading-[26px]  text-[#ffff] font-[400] font-hanken-grotesk"
                    onClick={() => handleButtonClickGradient(item)}
                    >
                      <div className="flex flex-row h-full items-centerjustify-center rounded-full w-full bg-[#222737]">
                        <div className="flex flex-row items-center ml-11">
                          <img src={union} alt="union Icon" className="w-[13.13px] h-[16.11px]" />
                          <p className="flex w-full ml-7 ">{item.displayText}</p>
                        </div>
                      </div>
                    </button>
                  ))}

              </div>

            )}
            {(kudzuplusTrue) && (
              <div className="flex flex-col items-center gap-4">
                {isClimbings.map((item) => (
                  
                  <button
                    key={item.id}
                    className={`w-[300px] md:h-[65px] sm:h-[60px] h-[60px] md:text-[16px] text-[15px] font-hanken-grotesk 
                   rounded-full px-4 py-2 text-white borderGradient 
                  ${item.code !== "CoveredByKudzu" ? item.optedIn : false ? 'opacity-50 cursor-not-allowed' : ''}`}
                    disabled={item.code === "CoveredByKudzu" && item.optedIn}
                    onClick={() => handleButtonClick(item)}
                  >
                    <div className="flex flex-row justify-center items-center">
                      <div className="flex items-center mr-2">
                        {/* <img src={checkrounded} alt="Icon" className="w-[17.5px] h-[17.5px]" /> */}
                      </div>
        
                        {( item.optedIn)?(
                          <div className="flex w-[170px] ml-4 relative right-[-15px]">{item.displayText}</div>

                        ):(<div className="flex w-[170px] ml-4 ">{item.displayText}</div>)}
                      
                          { item.optedIn && (
                            <div className="inline-block pl-3 align-middle">
                              <img src={Tickicon} alt="Tick Icon" />
                          </div>
                          )}
                    </div>
                  </button>
                ))}


               

              </div>

            )}

            {/* 'Skip' button */}
            <div className="sm:absolute sm:right-[-1rem] right-[4rem] bottom-[-1rem]">
              <div className="flex mt-32">
                <button
                  type="button"
                  className={`font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] ${kudzuplusTrue || showPrompt ? 'text-white opacity-50' : 'text-[#99AED7]'} flex items-center`}
                  onClick={MangageSpendAlerts}
                >
                  {t('skip')}
                </button>
              </div>
            </div>
          </div>
        }
      />

 {/* savings goals */}
 <Modal
 isOpen={isSpendModalOpen4}
 onClose={ () => {setSpendModalOpen4(false); setIsClimbFeaturesModalOpen(true);}}
 isClimbg={true}
 // subtitle={kudzuPlusTrue? <>
 //  <p className={SubHeadingStyles}>{t("Setup")} <span className="text-[#94C3E8]">{t('spendSense_alerts')}</span> {t('to get')} </p>
 //  <span className={SubHeadingStyles}>{addLineBreaks(t('notified*_when_you_spend_more_than_a_certain_daily'))}</span>
 //  </>
 //     :<>
 //   <span className={SubHeadingStyles}>{t("Setup")}</span>
 //   <span className={SubHeadingStyles2}>{t("SpendSenseAlerts")}</span>
 //   <span className={SubHeadingStyles}>{t("spendAlertsHeading")}</span>
 // </>
 // }
 content={
  <div>
  <p
    className={`${SubHeadingStyles} ${
      kudzuplusTrue || showPrompt ? "text-white" : ""
    }`}
  >
    {t("savings_goal_with")}{" "}
    <span
      className={`${
        kudzuplusTrue || showPrompt
          ? SubHeadingStyles2ForPlus
          : SubHeadingStyles2
      }`}
    >
      {t("saving_goals")}
    </span>{" "}
    {addLineBreaks(t("you_can_start_saving_your_goals"))}
  </p>
    <div className="">
      <img
      src={illoBeneficiaryDark}
      className=" m-auto my-[100px] w-[218px] md:h-[220.57px]"
      alt="saving_pig_box"
      />
      
    </div>
    <div className="md:right-[-50px] sm:right-[0px] bottom-[0.5rem] w-full">
        <div className="flex sm:justify-end justify-between md:gap-14 sm:gap-8 md:relative md:left-[80px]">
            <button
              type="button"
              className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
              text-[#4B70B9] flex items-center disabled"
              onClick={handleSavingGoals4}
            >
              {t("skip")}
            </button>
            <button
              type="button"
              className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
      text-[var(--climb-next-colr)] cursor-pointer flex items-center"
              onClick={() => handleSavingGoals1()}
            >
              {t("Learn_More")}
              <img
                src={appThemeData.arrowWhiteTwofac}
                className="md:w-[14px] sm:w-[11px]
md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
                alt="Arrow"
              />
            </button>
        </div>
      </div>
</div>

 }
/>
{/* saving goals 1 */}
<Modal
 isOpen={isHandleSavingGoals1}
 onClose={() => {setIsHandleSavingGoals1(false); setIsClimbFeaturesModalOpen(true);}}
 isClimbg={true}
 content={
   <div>
     <p
       className={`${SubHeadingStyles} ${
         kudzuplusTrue || showPrompt ? "text-white" : ""
       }`}
     >
       {t("Identify_your_unique")}{" "}
       <span
         className={`${
           kudzuplusTrue || showPrompt
             ? SubHeadingStyles2ForPlus
             : SubHeadingStyles2
         }`}
       >
         {t("saving_goals")}
       </span>{" "}
       {t("and_stay_on_track_with_automatic_recurring_contributions")}
     </p>
     <div className="pt-10 pb-10">
       <img
         src={Frame1336}
         className=" m-auto sm:w-[100px] h-[100px] md:w-[329px] md:h-[304px] mt-[100px]"
         alt="saving_pig_box"
       />
       {/* <div className="sm:absolute md:right-[-50px] sm:right-[0px] bottom-[0.5rem] w-full">
         <div className="flex justify-between sm:justify-end md:gap-14 sm:gap-8">
           <button
             type="button"
             className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
text-[var(--climb-skip-colr)] flex items-center disabled"
             onClick={MangageSpendAlerts}
           >
             {t("Questions_See_our_FAQ")}
           </button>
           <button
             type="button"
             className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
      text-[var(--climb-next-colr)] cursor-pointer flex items-center"
             onClick={() => handleSavingGoals2()}
           >
             {t("continue")}
             <img
               src={appThemeData.arrowWhiteTwofac}
               className="md:w-[14px] sm:w-[11px]
md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
               alt="Arrow"
             />
           </button>
         </div>
       </div> */}
     </div>
       <div className="w-full flex flex-row justify-between lg:mt-32 md:mt-20 mt-20">
           <div>
             <button
               type="button"
               className="sm:block hidden font-hanken-grotesk sm:font-bold font-[600]
                          lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)] md:relative md:right-[90px]"
             >
               {t("questions_see_our")}{" "}
               <button
                 onClick={() => {
                   navigate("/Help/FAQ");
                 }}
                 className="text-[var(--spend-sense-alert)]"
               >
                 {t("faq")}
               </button>
             </button>

             <button
               type="button"
               className="sm:hidden block font-hanken-grotesk sm:font-bold font-[600]
                          lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)]"
             >
               {" "}
               <button
                 onClick={() => {
                   navigate("/Help/FAQ");
                 }}
                 className="text-[var(--climb-skip-colr)]"
               >
                 {t("faq")}
               </button>
             </button>
           </div>

           <div className="">
             <button
               type="button"
               className="font-hanken-grotesk sm:font-bold font-[600]
lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--climb-next-colr)]
cursor-pointer flex items-center md:relative md:left-[60px]"
               onClick={() => handleSavingGoals2()}
             >
               {" "}
               {t("continue")}
               <img
                 src={appThemeData.arrowWhiteTwofac}
                 className="md:w-[14px] sm:w-[11px]
md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
                 alt="Arrow"
               />{" "}
             </button>
           </div>
       </div>
   </div>
 }
/>
<Modal
 isOpen={isHandleSavingGoals2}
// isOpen={true}
 onClose={() => {setIsHandleSavingGoals2(false); setIsClimbFeaturesModalOpen(true);}}
 isClimbg={true}
 content={
   <div>
     <p
       className={`${SubHeadingStyles} ${
         kudzuplusTrue || showPrompt ? "text-white" : ""
       }`}
     >
       {t("Regular_deposits_linked_to_each")}{" "}
       <span
         className={`${
           kudzuplusTrue || showPrompt
             ? SubHeadingStyles2ForPlus
             : SubHeadingStyles2
         }`}
       >
         {t("saving_goals")}
       </span>{" "}
       {t("allow_you_to_allocate_funds_towards_your_goals")}
     </p>

     <div className="py-10 mt-[60px] w-[346px] h-[220px] m-auto">
       <hr className="w-[346px] border-[#4B70B9]  border-2"/>

       <div className="flex justify-between items-center w-full py-[25px]">
       <p className="text-white font-hanken-grotesk text-[21px]">3% Each Deposit</p> 
       <div className="w-[24px] h-[24px] bg-[#FFFFFF] rounded-full"></div>
       </div>

       <hr className="w-[346px] border-[#4B70B9]  border-2"/>

       <div className="flex justify-between  items-center w-full py-[30px]">
       <p className="text-white font-hanken-grotesk text-[21px]">$10 Weekly</p> 
       <div className="w-[24px] h-[24px] bg-[#94C3E8] rounded-full"></div>
       </div>

       <hr className="w-[346px] border-[#4B70B9]  border-2"/>

       
     </div>
         <div className="w-full flex flex-row justify-between lg:mt-32 md:mt-20 mt-20">
           <div>
             <button
               type="button"
               className="sm:block hidden font-hanken-grotesk sm:font-bold font-[600]
                          lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)] md:relative md:right-[90px]"
             >
               {t("questions_see_our")}{" "}
               <button
                 onClick={() => {
                   navigate("/Help/FAQ");
                 }}
                 className="text-[var(--climb-skip-colr)]"
               >
                 {t("faq")}
               </button>
             </button>

             <button
               type="button"
               className="sm:hidden block font-hanken-grotesk sm:font-bold font-[600]
                          lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)]"
             >
               {" "}
               <button
                 onClick={() => {
                   navigate("/Help/FAQ");
                 }}
                 className="text-[var(--climb-skip-colr)]"
               >
                 {t("faq")}
               </button>
             </button>
           </div>

           <div className="">
             <button
               type="button"
               className="font-hanken-grotesk sm:font-bold font-[600]
lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--climb-next-colr)]
cursor-pointer flex items-center md:relative md:left-[76px]"
               onClick={() => handleSavingGoals3()}
             >
               {" "}
               {t("get_started")}
               <img
                 src={appThemeData.arrowWhiteTwofac}
                 className="md:w-[14px] sm:w-[11px]
md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
                 alt="Arrow"
               />{" "}
             </button>
           </div>
         </div>
   </div>
 }
/>
{/* last savingGoal modal */}
<Modal
 isOpen={isHandleSavingGoals3}
 onClose={() => {setIsHandleSavingGoals3(false); setIsClimbFeaturesModalOpen(true);}}
 isClimbg={true}
 content={
   <div>
     <p
       className={`${SubHeadingStyles} ${
         kudzuplusTrue || showPrompt ? "text-white" : ""
       }`}
     >
       {t("Share_your")}{" "}
       <span
         className={`${
           kudzuplusTrue || showPrompt
             ? SubHeadingStyles2ForPlus
             : SubHeadingStyles2
         }`}
       >
         {t("saving_goals")}
       </span>{" "}
       {t("with_family_and_friends")}
     </p>
     <div className="pt-10 pb-10">
       <img
         src={illoEmailUpdatedDarkNew}
         className="block m-auto mt-[100px] w-[210px] h-[210px]"
         alt="saving_pig_box"
       />
       {/* <div className="sm:absolute md:right-[-50px] sm:right-[0px] bottom-[0.5rem] w-full">
         <div className="flex justify-between sm:justify-end md:gap-14 sm:gap-8">
           <button
             type="button"
             className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
text-[var(--climb-skip-colr)] flex items-center disabled"
             onClick={MangageSpendAlerts}
           >
             {t("Questions_See_our_FAQ")}
           </button>
           <button
             type="button"
             className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
      text-[var(--climb-next-colr)] cursor-pointer flex items-center"
             onClick={() => handleSpendAlertIntoro2()}
           >
             {t("get_started")}
             <img
               src={appThemeData.arrowWhiteTwofac}
               className="md:w-[14px] sm:w-[11px]
md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
               alt="Arrow"
             />
           </button>
         </div>
       </div> */}
     </div>
       <div className="w-full flex flex-row justify-between lg:mt-32 md:mt-20 mt-20">
           <div>
             <button
               type="button"
               className="sm:block hidden font-hanken-grotesk sm:font-bold font-[600]
                          lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)] md:relative md:right-[80px]"
             >
               {t("questions_see_our")}{" "}
               <button
                 onClick={() => {
                   navigate("/Help/FAQ");
                 }}
                 className="text-[var(--climb-skip-colr)]"
               >
                 {t("faq")}
               </button>
             </button>

             <button
               type="button"
               className="sm:hidden block font-hanken-grotesk sm:font-bold font-[600]
                          lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)]"
             >
               {" "}
               <button
                 onClick={() => {
                   navigate("/Help/FAQ");
                 }}
                 className="text-[var(--climb-skip-colr)]"
               >
                 {t("faq")}
               </button>
             </button>
           </div>

           <div className="">
             <button
               type="button"
               className="font-hanken-grotesk sm:font-bold font-[600]
lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--climb-next-colr)]
cursor-pointer flex items-center md:relative md:left-[66px]"
               onClick={() =>handleSavingGoals4() }
             >
               {" "}
               {t("get_started")}
               <img
                 src={appThemeData.arrowWhiteTwofac}
                 className="md:w-[14px] sm:w-[11px]
md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1"
                 alt="Arrow"
               />{" "}
             </button>
           </div>
         </div>
   </div>
 }
/>



{/* FIXME: last modal for SaveGoal TODO: update content*/}
<Modal
        isOpen={isHandleSavingGoals4}
        onClose={() => {
          if (savingsGoalsIntoTrue) {
            initialSavingsGoalModalClose(false)
            setIsHandleSavingGoals4(false);
          } else {
            setIsHandleSavingGoals4(false); setIsClimbFeaturesModalOpen(true); navigate('/Climb/SavingGoals/ManageSavingGoal')
          }
         }}
        isClimbg={true}
        subtitle={
          <>
            <p className={SubHeadingStyles2}>{t("saving_Goals_content_title")}</p>
            <p className="font-hanken-grotesk mt-10 font-[500] md:text-[20px] sm:text-[12px] text-[14px] sm:leading-[18px] md:leading-[24px] leading-[25px] text-[var(--modal-text-heading-clr)]">
              {t("saving_Goals_content")} <span className="font-hanken-grotesk  md:text-[20px] sm:text-[12px] text-[14px] text-[#94C3E8] cursor-pointer" onClick={() => {setIsHandleSavingGoals4(false); setSpendModalOpen4(true);  setIsHandleSavingGoals4(false); }}>{t('Learn_more')}</span>
            </p>
            <p className="font-hanken-grotesk font-[500] sm:text-[10px] md:text-[16px] text-[16px] sm:leading-[16px] pt-8  text-[var(--modal-text-heading-clr)]">
              {"Learn more about Climb in "}
              <span
                className="text-[var(--modal-text-highlight)] cursor-pointer"
                onClick={() => navigate("/PayPerks")}
              >
                {t("NavbarPerks")}
              </span>
              .
            </p>
          </>
        }
        content={
          <div className="pb-10">
            <img
              src={illoBeneficiaryDark}
              alt=""
              className="m-auto my-[88px] w-[218px] md:h-[220.57px]"
            />
            <div className="flex justify-center text-center w-full items-center">
              <button
                type="button"
                className="w-full font-hanken-grotesk sm:font-bold font-[600]
              lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px]
             text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
                onClick={() => {
                  // FIXME:
                  if (savingsCardExist) {
                    navigate("/Climb/SavingGoals");
                  } else {
                    setIsHandleSavingGoals4(false)
                    // setIsSavingHabitModalOpen3(false);
                    setIsCoveredByKudzuIneligibleSetupSavings(true);
                    setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false);
                  }
                  logFirebaseEvents(
                    "climb",
                    "Set_Saving_Goal_Clicked",
                    "Set_Saving_Goal_Clicked",
                    "",
                    ""
                  );
                }}
              >
                {t("savings_goals_btm_text")}
                {/* <img
                src={appThemeData.arrowWhiteTwofac}
                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                     h-[14px] ml-1"
                alt="Arrow" /> */}
              </button>
            </div>
          </div>
        }
      />


      {/* //spending alerts intro 1 */}

      <Modal
        isOpen={isSpendModalOpen1}
        onClose={closeSkipModal}
        isClimbg={true}
        subtitle={kudzuPlusTrue? <>
         <p className={SubHeadingStyles}>{t("Setup")} <span className="text-[#94C3E8]">{t('spendSense_alerts')}</span> {t('to get')} </p>
         <span className={SubHeadingStyles}>{addLineBreaks(t('notified*_when_you_spend_more_than_a_certain_daily'))}</span>
         </>
            :<>
          <span className={SubHeadingStyles}>{t("Setup")}</span>
          <span className={SubHeadingStyles2}>{t("SpendSenseAlerts")}</span>
          <span className={SubHeadingStyles}>{t("spendAlertsHeading")}</span>
        </>
        }
        content={
          <div>
            <p className="font-400 leading-[18px] text-[12px] sm:leading-[20px] md:text-[16px] md:leading-[24px] text-[var(--spend-sub-color)] mt-4">{t("climb_menu_note")}</p>
            <div className="pt-10 pb-10">
              <img src={appThemeData.kudzu_spend} className="block m-auto mb-20 sm:mb-10 w-[100px] h-[100px] md:w-[155px] md:h-[155px]" />
              <div className="sm:absolute md:right-[-50px] sm:right-[0px] bottom-[0.5rem] w-full">
                <div className="flex sm:justify-end justify-between md:gap-14 sm:gap-8">
                  <button
                    type="button"
                    className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
     text-[var(--climb-skip-colr)] flex items-center disabled"
                    onClick={MangageSpendAlerts}
                  >
                    {t('skip')}
                  </button>
                  <button
                    type="button"
                    className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
             text-[var(--climb-next-colr)] cursor-pointer flex items-center"
                    onClick={() => handleSpendAlertIntoro2()}
                  >
                    {t('Learn_More')}<img src={appThemeData.arrowWhiteTwofac} className="md:w-[14px] sm:w-[11px]
   md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1" alt="Arrow" />
                  </button>
                 
                </div>
              </div>
            </div>
          </div>
        }
      />



      {/* //spending alerts intro 2 */}


      <Modal
        isOpen={isSpendModalOpen2}
        onClose={closeSkipModal}
        isClimbg={true}
        subtitle={kudzuPlusTrue ? <><p><span className={SubHeadingStyles2}>{t("spendSense_alerts")}</span> <span className={SubHeadingStyles}>{addLineBreaks(t('spendsenseAlert2Plus'))}</span></p></> :
        <>
          <span className={SubHeadingStyles}>{t("SpendSenseAlerts")}</span>
          <span className={SubHeadingStyles}>{t("spendAlerts2Heading")}</span>
        </>
        }
        content={<div className="pt-10 pb-10">
          <img src={appThemeData.SpendSenseIcon2} className="block m-auto md:w-[265px] md:h-[175px] w-[175px] h-[117px] mb-20 sm:mb-10 " alt="" />
          {/* <div className="absolute sm:right-[-1rem] right-[-1rem] bottom-[0.5rem] flex gap-6"> */}
          {/* <div className="sm:absolute md:right-[-50px] sm:right-[0px] bottom-[0.5rem] w-full">
            <div className="flex sm:justify-end justify-between md:gap-14 sm:gap-8">

              <button
                type="button"
                className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
     text-[#99AED7] flex items-center disabled"
                onClick={MangageSpendAlerts}
              >
                {t('skip')}
              </button>
              <button
                type="button"
                className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
             text-[#2965FB] cursor-pointer flex items-center"
                onClick={() => handleSpendAlertIntoro3()}
              >
                {t('continue')}
              </button>
            </div>

          </div> */}

          <div className="w-full flex flex-row justify-between lg:mt-32 md:mt-20 mt-20">
            <div>
              <button
                type="button"
                className="sm:block hidden font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)]"
              >
                {t('questions_see_our')} <button onClick={() => { navigate('/Help/FAQ') }}
                  className="text-[var(--climb-skip-colr)]">{t('faq')}</button>
              </button>

              <button
                type="button"
                className="sm:hidden block font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)]"
              >  <button onClick={() => { navigate('/Help/FAQ') }}
                className="text-[var(--climb-skip-colr)]">{t('faq')}</button>
              </button>
            </div>

            <div className="">
              <button type="button" className="font-hanken-grotesk sm:font-bold font-[600]
 lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--climb-next-colr)]
 cursor-pointer flex items-center" onClick={() => handleSpendAlertIntoro3()}>  {t('get_started')}<img src={appThemeData.arrowWhiteTwofac} className="md:w-[14px] sm:w-[11px]
  md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1" alt="Arrow" /> </button>
            </div>
          </div>


        </div>}
      />





      {/* //spending alerts intro 3 */}

      <Modal
        isOpen={isSpendModalOpen3}
        onClose={closeSkipModal}
        isClimbg={true}
        subtitle={<>
          <p className={SubHeadingStyles2} style={{ width: '453px' }}> {addLineBreaks(t('letsStartSpendAlerts'))}</p>
          <p className={SubHeadingStyles3}>{t("settingSpendAlerts")}</p>
        </>
        }
        content={<div className="pt-5 pb-10">
          <img src={appThemeData.climbAddalerts} className="block m-auto mb-20 sm:mb-10 w-[100px] h-[100px] md:w-[155px] md:h-[155px]" alt="" />
          <div className="flex justify-center text-center w-full items-center">
            <button
              type="button"
              className="w-full font-hanken-grotesk sm:font-bold font-[600] 
              lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px]
             text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
              onClick={() => { navigate('/Climb/AddSpendAlerts') }}
            >
              {t('spendBtnText')}
            </button>
          </div>
        </div>}
      />

      {/* //Saving Habits intro 1 */}

      <Modal
        isOpen={isSavingHabitModalOpen1}
        onClose={closeSkipModal}
        isClimbg={true}
        subtitle={<div className="w-[90%] md:w-full">
          <span className={SubHeadingStyles}>{t("Setup")}</span>
          <span className={SubHeadingStyles2}> {t("saving_habits")} </span>
          <span className={SubHeadingStyles}>{addLineBreaks(t("saving_habits_heading"))}</span>
        </div>
        }
        content={<div className="pt-10 pb-24">
          <img src={appThemeData.climbSavingsHabitImg} className="block m-auto w-2/5 h-2/5" />
          <div className="absolute sm:right-[-1rem] right-[-1rem] bottom-[0.5rem] flex gap-6">
            <button
              type="button"
              className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
              text-[var(--climb-skip-colr)] flex items-center disabled"
              onClick={MangageSpendAlerts}
            >
              {t('skip')}
            </button>
            <button
              type="button"
              className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
              text-[var(--climb-next-colr)] cursor-pointer flex items-center"
              onClick={() => handleSavingsHabitIntro2()}
            >
              {t('Learn_More')}<img
                src={appThemeData.arrowWhiteTwofac}
                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                     h-[14px] ml-1"
                alt="Arrow" />
            </button>
          </div>
        </div>}
      />

   

      {/* //Saving Habits intro 2 */}
      <Modal
        isOpen={isSavingHabitModalOpen2}
        onClose={closeSkipModal}
        isClimbg={true}
        subtitle={<>
          <span className={SubHeadingStyles}>{t("saving_habits2_heading1")}</span>
          <span className={SubHeadingStyles2}> {t("saving_habits2_heading2")}</span>
        </>
        }
        content={
          <>

            <div className=" m-auto pt-20 pb-20 h-2/5 w-2/5">
              <img src={appThemeData.savingsHabitsIcon2} className="block m-auto" />
            </div>
            <div className="w-full flex flex-row justify-between lg:mt-32 md:mt-20 mt-20">
              <div>
                <button
                  type="button"
                  className="sm:block hidden font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)]"
                >

                  {t('questions_see_our')} <button onClick={() => { navigate('/Help/FAQ'); logFirebaseEvents("climb", "Faq_Saving_Alert_Skip_Clicked", "Faq_Saving_Alert_Skip_Clicked", "", ""); }}
                    className="text-[var(--climb-skip-colr)]">{t('faq')}</button>
                </button>

                <button
                  type="button"
                  className="sm:hidden block font-hanken-grotesk sm:font-bold font-[600]
                                 lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px] text-[var(--modal-text-heading-clr)]"
                >  <button onClick={() => { navigate('/Help/FAQ') }}
                  className="text-[var(--climb-skip-colr)]">{t('faq')}</button>
                </button>
              </div>

              <div className="">
                <button type="button" className="font-hanken-grotesk sm:font-bold font-[600]
 lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--climb-next-colr)]
 cursor-pointer flex items-center" onClick={() => handleSavingsHabitIntro3()}>  {t('get_started')}<img src={appThemeData.arrowWhiteTwofac} className="md:w-[14px] sm:w-[11px]
  md:h-[14px] sm:h-[11px] w-[14px] h-[14px] ml-1" alt="Arrow" /> </button>
              </div>
            </div>


            {/* <div className="absolute sm:right-[-1rem] right-[-1rem] bottom-[0.5rem] flex gap-6">
              <button
                type="button"
                className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
           text-[#99AED7] flex items-center disabled"
              // onClick={MangageSpendAlerts}
              >
                {t('skip')}
              </button>
              <button
                type="button"
                className="font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px]
                   text-[#2965FB] cursor-pointer flex items-center"
                onClick={() => handleSavingsHabitIntro3()}
              >
                {t('get_started')}<img
                  src={Arrow}
                  className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                     h-[14px] ml-1"
                  alt="Arrow" />
              </button>
            </div> */}


          </>}
      />

      {/* //Saving Habits intro 3 */}

      <Modal
        isOpen={isSavingHabitModalOpen3}
        onClose={closeSkipModal}
        isClimbg={true}
        subtitle={<>
          <p className={SubHeadingStyles2}>{t('saving_habits3_content1')}</p>
          <p className='font-hanken-grotesk mt-5 font-[500] md:text-[20px] sm:text-[12px] text-[14px] sm:leading-[18px] md:leading-[24px] leading-[25px] text-[var(--modal-text-heading-clr)]'>{t("saving_habits3_content2")}</p>
          <p className='font-hanken-grotesk font-[500] sm:text-[10px] md:text-[16px] text-[16px] sm:leading-[16px] pt-5  text-[var(--modal-text-heading-clr)]'>{'Learn more about Toolkit in '}<span className="text-[var(--modal-text-highlight)] cursor-pointer" onClick={() => navigate("/PayPerks")}>{'PayPerks'}</span>.</p>
        </>
        }
        content={<div className="pb-10">
          <img src={appThemeData.climbSavingsHabitImg} alt="" className="block m-auto h-2/5 w-2/5 py-5" />
          <div className="flex justify-center text-center w-full items-center">
            <button
              type="button"
              className="w-full font-hanken-grotesk sm:font-bold font-[600] 
              lg:text-[18px] md:text-[17px] sm:text-[13px] text-[16px]
             text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
              onClick={() => { if (savingsCardExist) { navigate('/Climb/AddSavingsHabit') } else { setIsSavingHabitModalOpen3(false); setIsCoveredByKudzuIneligibleSetupSavings(true); setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false) } logFirebaseEvents("climb", "Set_Saving_Habit_Clicked", "Set_Saving_Habit_Clicked", "", ""); }}
            >
              {t('savings_habit_btm_text')}
              {/* <img
                src={appThemeData.arrowWhiteTwofac}
                className="md:w-[14px] sm:w-[11px] md:h-[14px] sm:h-[11px] w-[14px]
                     h-[14px] ml-1"
                alt="Arrow" /> */}
            </button>
          </div>
        </div>}
      />

      <Modal
        isOpen={isCoveredByKudzuIneligibleSetupSavings}
        onClose={() => {
          if (isCoveredByKudzuIneligibleSetupSavings) {
            setIsCoveredByKudzuIneligibleSetupSavings(false);
            setIsClimbFeaturesModalOpen(true)
          }
        }}
        isClimbg={true}
        Fullheight={true}
        subtitle={<div className="">
          <span className={SubHeadingStyles2}>{t('sorry')}, </span>
          <span className={SubHeadingStyles}>{t("it_looks_like_your_not_eligible_right_now")}</span>
          <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
            {LineBreaks(t("you_need_savings_account_updated"))}</p>
        </div>
        }
        content={<div>

          <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon}
            className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" />

          <div className="flex flex-col justify-center items-center gap-8 w-full">
            <button
              type="button"
              className=" w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
              onClick={canCreateSavingsAccount}
              autoFocus
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  canCreateSavingsAccount()
                  // setIsCoveredByKudzuIneligibleSetupSavings(false);
                  // setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(true);
                  event.stopPropagation();
                }
              }}
            >
              {t('enroll_in_savings_account')}
            </button>
            <button
              type="button"
              className={`w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--modal-text-highlight)] cursor-pointer flex justify-center items-center p-4 sm:border-[0px]  border-[#2965FB] border-[2.5px]`}
              onClick={() => {
                setIsCoveredByKudzuIneligibleSetupSavings(false);
                navigate('/Climb/ClimbMenu');
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  setIsCoveredByKudzuIneligibleSetupSavings(false);
                  navigate('/Climb/ClimbMenu');
                  event.stopPropagation();
                }
              }}
            >
              {t('back_to_climb')}
            </button>
          </div>
        </div>}
      />

{/* inEleigible modal for covered by kudzu plus  */}

      <Modal
        isOpen={isCoveredByKudzuPlusIneligible}
        onClose={() => {
          if (isCoveredByKudzuPlusIneligible) {
            setIsCoveredByKudzuPlusIneligible(false)
            setIsClimbFeaturesModalOpen(true)
          }
        }}
        isClimbg={true}
        Fullheight={true}
        subtitle={<div className="">
          <span className={SubHeadingStyles2}>{t('sorry')}, </span>
          <span className={SubHeadingStyles}>{t("it_looks_like_your_not_eligible_right_now")}</span>
          <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
            {t("you_need_minimum_100_spending")}  <span className='text-[var(--modal-text-highlight)] cursor-pointer' onClick={ handleTermsClick }>{t('here')}</span>.</p>
        </div>
      }
        content={<div>

          <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon}
            className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" />

          <div className="flex flex-col justify-center items-center gap-8 w-full">
            <button
              type="button"
              className=" w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
              onClick={() => { setIsCoveredByKudzuPlusIneligible(false); navigate('/AccountServices/Spending/TransferMoney') }}
              autoFocus
            >
             {t('addMoney')}
            </button>
            <button
              type="button"
              className={`w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[var(--modal-text-highlight)] cursor-pointer flex justify-center items-center p-4 sm:border-[0px]  border-[#2965FB] border-[2.5px]`}
              onClick={() => {
                setIsCoveredByKudzuPlusIneligible(false);
                navigate('/Climb/ClimbMenu');
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  setIsCoveredByKudzuPlusIneligible(false);
                  navigate('/Climb/ClimbMenu');
                  event.stopPropagation();
                }
              }}
            >
              {t('back_to_climb')}
            </button>
          </div>
        </div>}
      />
      <Modal
        // bgColor={'bg-[#FEFAEE]'}
        isOpen={isCoveredByKudzuIneligibleSetupSavingsPostPopup}
        onClose={() => {
          if (isCoveredByKudzuIneligibleSetupSavingsPostPopup) {
            setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false);
            setIsCoveredByKudzuIneligibleSetupSavings(true)
          }
        }}
        isClimbg={true}
        Fullheight={true}
        subtitle={<div className="">
          <span className={SubHeadingStyles2}>{t('lets_get_started').replace('!', '')} </span>
          <span className={SubHeadingStyles}>{t("with_creating_a_new_account")}</span>
          <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
            {t("set_aside_money_for_things_that_matter")}</p>
        </div>
        }
        content={<div>

          <img src={require('../../../assets/images/kudzu_piggy_bank.png')} className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" />

          <div className="flex flex-col justify-center items-center gap-8 w-full">
            <button
              type="button"
              className=" w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
              onClick={() => {
                setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false); dispatch({ type: 'SSN_SCREEN_THROUGH', payload: { ssnScreenThrough: t('came_from_climb') } });
                navigate('/SetupSavingsAccount');
              }}
              autoFocus
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  setIsCoveredByKudzuIneligibleSetupSavingsPostPopup(false);
                  navigate('/SetupSavingsAccount');
                  event.stopPropagation();
                }
              }}
            >
              {t('continue')}
            </button>
          </div>
        </div>}
      />
      <Modal
        isOpen={isCoveredByKudzuIneligible}
        onClose={closeCustomAlertModal}
        isClimbg={true}
        Fullheight={true}
        subtitle={<div className="">
          <span className={SubHeadingStyles2}>{t('sorry')}, </span>
          <span className={SubHeadingStyles}>{t("it_looks_like_your_not_eligible_right_now")}</span>
          <p className='mt-4 font-hanken-grotesk font-[500] md:text-[18px] sm:text-[14px] text-[16px] sm:leading-[23px] lg:leading-[30px] md:leading-[30px] leading-[24px] text-[var(--modal-text-heading-clr)]'>
            {t("you_need_minimum_50")}</p>
        </div>
        }
        content={<div>

          <img src={appThemeData.coveredByKudzuIneligibleineligibleIcon}
            className="block m-auto lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-16 md:my-14 sm:my-10 my-10" />

          <div className="flex flex-col justify-center items-center gap-8 w-full">
            <button
              type="button"
              className="focus:outline-none   w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-white bg-[#2965FB] cursor-pointer flex justify-center items-center p-4"
              onClick={() => { navigate('/AccountServices/Spending/TransferMoney') }}
              autoFocus
            >
              {'Add Money to Savings'}
            </button>
            <button
              type="button"
              className="w-full font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[14px] text-[16px] text-[#2965FB] cursor-pointer flex justify-center items-center p-4"
              onClick={() => {
                setIsCoveredByKudzuIneligible(false);
                setIsClimbFeaturesModalOpen(true);
                // navigate('/Climb/ClimbMenu');
              }}>
              {/* {'Maybe later'} */}
              {t('back_to_climb')}
            </button>
          </div>
        </div>}
      />
      <CustomAlertModel isOpen={showModel}
        onClose={closeCustomAlertModal1}
        image={modelImage}
        zIndex={300}
        highlightMsg={<p className={`${HighlightMsgStyles} sm:flex block flex-col`}>{highlightMsg}
          <span className={`${HeaderMsgStyles} ${savingsTheme ? 'text-[#0C4437]' : 'text-black'}`}> {headerMsg}</span></p>}
        subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text} btn2Text={btn2Text}
        btn1TypeAcpt={btn1TypeAcpt}
        verificationFailure={() => { }}
        footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
        onAcptBtnClick={onAcptBtnClick}
        onCancelBtnClick={onCancelBtnClick}
        isBorderNone={isBorderNone}
        subFooter={isSubFooter && subComponent()}
      />
      {/* //kudzu plus modal */}

      <CustomModalPlus isOpen={showPlusModal} onClose={closeModelPlus}
        image={modelImage}
        carousel={carousel}
        comparisonScreen={comparisonScreen}
        summaryParagraph={summaryParagraph ? <p className={summaryParagraphStyles}>{summaryParagraph}</p> : ""}
        isBorderNone={isBorderNone}
        highlightMsg={<p className={HeaderMsgStylesForPlus}> {headerMsg}</p>}
        subHeaderMsg={subHeaderMsg ? <p className={SubHeaderMsgStylesPlus}>{subHeaderMsg}</p> : ""}
        btn1Exists={btn1Exists}
        btn2Exists={btn2Exists}
        btn1Text={btn1Text}
        btn1BgColor={btn1BgColor}
        btn2Text={btn2Text}
        opacityLow={opacityValueLow}
        defaultCornerRadius={false}
        btn1TypeAcpt={btn1TypeAcpt}
        fullWidth={fullWidth}
        onAcptBtnClick={onAcptBtnClickPlusModal}
        onCancelBtnClick={onCancelBtnClickPlusModal}
        footerButtonEnable={footerButtonEnable}
        skipAndNextButtonsEnable={skipAndNextButtonsEnable}
        gradientButton={gradientButton}
        largeImage={largeImage}
        subFooter={subFooter}
      />
      {isLoading && <Loader />}
    </div>

  )
}

export default withOidcSecure(Climb)


